import { Box } from '../../primitives';
import { styled } from '../../theme';

export const Column = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
`;
